import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { colors } from '@prisjakt/ui-base';

import { flexStyle, gutterStyle } from '../../styles';

export const ViewAllLink = styled(Link)`
  color: ${colors.darkGray2};
  font-weight: 400;
  margin-top: 0.75em;
  padding-bottom: 0.25em;
`;

export const Wrapper = styled.div`
  ${flexStyle}
  ${gutterStyle}

  && {
    min-width: 100%;
  }
`;
